// RoutingGraphCacheManager.ts

import { AbstractWebStorageCacheManager } from "@/services/cache/AbstractWebStorageCacheManager";
import { GraphsMap, RoutingGraph, RoutingGraphNode, RoutingGraphEdge } from "../types/routing";
import { isSerializedGraphsMap } from "../utils/typeGuard";

const STORAGE_KEY = "routingGraphSessionCache";
/**
 * RoutingGraphのデータをsessionStorageで管理するクラス
 */
export class RoutingGraphCacheManager extends AbstractWebStorageCacheManager<GraphsMap> {
  constructor(key: string = STORAGE_KEY, storageType: "session" | "local" = "session") {
    super(key, storageType);
  }

  // Map<string, RoutingGraph> を JSON互換のオブジェクトに変換
  public serialize(graphsMap: GraphsMap): object {
    const jsonObject: Record<string, unknown> = {};
    graphsMap.forEach((graph, graphKey) => {
      jsonObject[graphKey] = {
        nodes: Array.from(graph.nodes.entries()),
        edges: Array.from(graph.edges.entries()),
        floorId: graph.floorId,
      };
    });
    return jsonObject;
  }

  // JSON互換のオブジェクトから Map<string, RoutingGraph> に復元
  public deserialize(jsonObject: unknown): GraphsMap | null {
    // 2. 型ガードチェックの実行
    if (!isSerializedGraphsMap(jsonObject)) {
      console.error("Cache structure is invalid and cannot be made into GraphMap.");
      return null;
    }

    const graphsMap = new Map<string, RoutingGraph>();

    Object.entries(jsonObject).forEach(([graphKey, graphValue]) => {
      try {
        if (graphValue && graphValue.nodes && graphValue.edges && graphValue.floorId) {
          const nodesMap = new Map<string, RoutingGraphNode>(graphValue.nodes);
          const edgesMap = new Map<string, RoutingGraphEdge[]>(graphValue.edges);

          const graph: RoutingGraph = {
            nodes: nodesMap,
            edges: edgesMap,
            floorId: graphValue.floorId,
          };
          graphsMap.set(graphKey, graph);
        }
      } catch (e) {
        console.error(`Failed to deserialize graph key ${graphKey}:`, e);
      }
    });

    return graphsMap;
  }
}
